module.exports = __webpack_public_path__ + "img/lifecycles.39e60d23.svg";